module.exports = __webpack_public_path__ + "img/OPI-Banner-04.908cc0d9.jpg";